import { render } from "./IconCheck.vue?vue&type=template&id=2fd74e0b"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"
script.render = render

export default script